import {Injectable} from '@angular/core';
import {ToolsService} from '../../../services/tools.service';
import {EnumsService} from '../../../services/enums.service';
import {UrlValidatorService} from '../../../services/url-validator.service';
import {ActivatedRouteSnapshot} from '@angular/router';
import {AllowedParamGroup} from '../../../types/AllowedParamGroup';
import {RoutesQueryParamsEnum} from '../../../enums/RoutesEnums';

@Injectable()
export class CareproviderUnitUrlResolverService {
  constructor(
    private tools: ToolsService,
    private enumsService: EnumsService,
    private urlValidator: UrlValidatorService,
  ) {}

  public cleanUpUrl(snapshot: ActivatedRouteSnapshot): boolean {
    const allowedQueryParams: string[] = [
      RoutesQueryParamsEnum.PREVIEW,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW_IU,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW_GDFP,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW_LINEID,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW_CREATIVEID,
      RoutesQueryParamsEnum.GCLID,
      RoutesQueryParamsEnum.UTM_CAMPAIGN,
      RoutesQueryParamsEnum.UTM_SOURCE,
      RoutesQueryParamsEnum.UTM_MEDIUM,
      RoutesQueryParamsEnum.UTM_SIZE,
      RoutesQueryParamsEnum.UTM_TERM,
      RoutesQueryParamsEnum.UTM_CONTENT,
      RoutesQueryParamsEnum.FBCLID,
      RoutesQueryParamsEnum.REVIEW_RATING_KEY,
      RoutesQueryParamsEnum.BOOKING_STEP,
      RoutesQueryParamsEnum.WIDGET_LISTNING_ACTION,
    ];
    const allowedParamsGroups: AllowedParamGroup[] = [];

    allowedParamsGroups.push({
      params: [
        {
          type: 'id-slug',
          value: null,
        },
      ],
    });

    allowedParamsGroups.push({
      params: [
        {
          type: 'string',
          value: null,
        },
      ],
    });

    const segment = '_routerState';
    const firstSegment = snapshot[segment].url.split('/')[1];
    const routingBase: string[] = ['/', firstSegment];
    return this.urlValidator.cleanUpUrlAndRedirect(snapshot, routingBase, allowedParamsGroups, allowedQueryParams);
  }
}
